import React, { FC, useMemo } from "react";
import classes from "./Header.module.css";
import logo from "../../Utils/images/name-logo.png";
import logoMobile from "../../Utils/images/icon-logo.png";
import HeadCenterTab from "./HeadCenterTab";
import { RootState } from "../../reducers/RootReducer";
import { connect, ConnectedProps } from "react-redux";
import ExitButton from "../ExitButton";
import { PropsFromScreenManager } from "../../types";
import CONSTANTS from "../../constant/general";

const mapStateToProps = (state: RootState) => ({
  header: state.header,
  stateManager: state.stateManager,
  ring: state.ring,
  diamond: state.diamond,
  settingFilter: state.settingFilter,
  table: state.table,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PropsFromHeaderRedux = ConnectedProps<typeof connector>;
interface HeaderProps {
  isStuds?: boolean;
}
const Header: FC<PropsFromHeaderRedux & PropsFromScreenManager & HeaderProps> = (props) => {
  const {
    table,
    settingFilter,
    diamond,
    ring,
    header,
    stateManager,
    instanceData: { screenManager },
    iframeLoadActionCount,
    isStuds
  } = props;
  // const {renderMenuContent, mobileMenu} = useHeader();
  // const {
  //   renderMenuContent,
  //   mobileMenu,
  //   isOpenDialog,
  //   closeDialogBox,
  //   openDialogBox,
  // } = useHeader();

  const handleLogoLink = () => {
    [ CONSTANTS.RPID, CONSTANTS.BUILDER_MODE_KEY, CONSTANTS.DESIGN_UUID, "previousPath" ].forEach((key) =>
      localStorage.removeItem(key)
    );
    //@ts-ignore
    window.location.href = window.location.origin;
  };
  const isSelectedDiamond = useMemo(()=> header?.tabData?.find((tab)=> tab.label === "SELECT DIAMOND"  && tab.isIcon), [header?.tabData]);

  return (
    <div className={classes.header}>
      <div className={`${classes.container} hk_container`}>
        <div className={classes.logoWrap}>
          {/* <div className={classes.logoLink} onClick={()=>(screenManager as any).changeScreen({ viewName: 'home', id: null })}> */}

          <button
            type={"button"}
            className={classes.logoLink}
            onClick={handleLogoLink}
          >
            <picture className={classes.logo}>
              <source media="(max-width:1079px)" srcSet={logoMobile} />
              <img src={logo} className="w-32" alt="logo" />
            </picture>
          </button>
        </div>
        {header?.tabData && (
          <HeadCenterTab
            tabData={header.tabData}
            instanceData={{ screenManager }}
            isDisabledTab={
              (isSelectedDiamond && ["square cushion","heart"].includes(diamond?.details?.shape?.toString()?.toLowerCase() as string))||
              table.isLoading ||
              settingFilter.isProductLoading ||
              diamond.isLoading ||
              ring.isLoading
            }
            iframeLoadActionCount={iframeLoadActionCount}
          />
        )}
        <ExitButton
          instanceData={{ screenManager }}
          previousPath={header.previousPath}
          isStuds={isStuds}
        />
        {/* <div className={classes.link} onClick={openDialogBox}>
                <Icon name={'hk-exit'} className={classes.icon} />
                <span className={classes.linkText}>Data</span>
              </div> */}
        {/* <div className={classes.helpWrap}>
                    {renderMenuContent()}
                    <div
                        className={`${classes.helpInner} ${
                            mobileMenu ? classes.active : ""
                        }`}
                    >
                        <Link className={classes.link} to="/help">
                            <Icon name="hk_help" className={classes.icon}/>
                            <span className={classes.linkText}>Help</span>
                        </Link>
                        <div className={classes.link}>
                            <Icon name={"hk-exit"} className={classes.icon}/>
                            <span className={classes.linkText}>Exit</span>
                        </div>
                    </div>
                </div>*/}
      </div>
    </div>
    // {/* <DialogBox
    //   isOpen={isOpenDialog}
    //   closeModal={closeDialogBox}
    //   title={'Memory Manager'}
    // >
    //   <div>
    //     {Object.keys(stateManager.options).map((key) => (
    //       <div key={key}>
    //         <strong>{key}:</strong>{' '}
    //         {JSON.stringify(stateManager.options[key])}
    //       </div>
    //     ))}
    //   </div>
    // </DialogBox> */}
  );
};

export default connector(Header);
